import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './row.styl'

export default class Row extends Component {
  static propTypes = {
    justifyCenter: PropTypes.bool,
    alignCenter: PropTypes.bool,
    spaceAround: PropTypes.bool,
    spaceBetween: PropTypes.bool,
    column: PropTypes.bool,
    stretch: PropTypes.bool,
    gutters: PropTypes.bool,
    children: PropTypes.any
  }

  static defaultProps = {
    inner: false
  }

  render() {
    const { children, gutters, justifyCenter, alignCenter, spaceAround, spaceBetween, stretch, column } = this.props
    const marginHor = 8
    let element = React.cloneElement(children, { margin: marginHor, gutters })

    if (Array.isArray(children)) {
      element = children.map((child, key) => React.cloneElement(child, { margin: marginHor, key, gutters }))
    }

    let alignItems = 'flex-start'
    let justifyContent = 'flex-start'
    let flexDirection = 'row'

    justifyContent = justifyCenter ? 'center' : justifyContent
    justifyContent = spaceAround ? 'space-around' : justifyContent
    justifyContent = spaceBetween ? 'space-between' : justifyContent
    alignItems = alignCenter ? 'center' : alignItems
    alignItems = stretch ? 'stretch' : alignItems
    flexDirection = column ? 'column' : flexDirection

    return (
      <div
        style={{
          alignItems,
          justifyContent,
          flexDirection,
          width: '100%',
          height: '100%',
          margin: `0 ${gutters ? -marginHor : 0}px`
        }}
        className={styles.row}
      >
        {element}
      </div>
    )
  }
}
